module.exports = __webpack_public_path__ + "static/img/t5-4.6f424df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/t5-4.png
// module id = DmwO
// module chunks = 1